import React from "react";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import useSnackbar from "../../../hooks/useSnackbar";
import { getTransactionCustom } from "../../../api/transaction-type";
import AgGridPaginatedTable from "../../../components/AgGridPaginatedTable";
import { GridComp6 } from "../../../components/GridComponents";
import {
  salesOrderFAMDepreciationHistoryTable,
  salesOrderFamAssetTable,
  salesOrderCustomJournalRejectReasonTable,
  invoiceFamAssetTable,
  invoiceCustomJournalRejectReasonTable,
  invoiceFAMDepreciationHistoryTable,
  BgSummaryrecordTable,
  BgIncomeTable,
  BgDeprecitionHistoryTable,
  BgFAMAssetTable,
} from "../../../config/grid-column-defs";
import { slugMap } from "../../../config/slug-config";
import { useParams } from "react-router-dom";
import {
  Box,
  Grid,
  Checkbox,
  InputLabel,
  FormControl,
  FormControlLabel,
  FormGroup,
  Tabs,
  Tab,
  MenuItem,
  Select,
  Stack,
  Button,
} from "@mui/material";
import TabPanel from "../../../components/TabPanel";
import { CustomCheckBox } from "../../../components/CheckboxComp";
import { GridComp4 } from "../../../components/GridComponents";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  spacedTabs: {
    "& .MuiTab-root": {
      marginRight: theme.spacing(2), // Adjust the spacing as needed
    },
  },
}));

export default function InvoiceCustom({ tabIndexP }) {
  const classes = useStyles();
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);
  const pageDetail = slugMap[params.slug];
  const [rowData, setRowData] = useState({});
  const [tabIndexRelatedRecord, setTabIndexRelatedRecord] = useState(0);
  useEffect(() => {
    if (user.token) {
      getTransactionCustomDetailData();
    }
  }, []);

  async function getTransactionCustomDetailData() {
    setLoading(true);
    try {
      const { data } = await getTransactionCustom(user.token, {
        id: params.docNo,
      });
      console.log("jhsjjs", data.data.data[0]);
      setRowData(data.data.data[0]);
      setLoading(false);
      // return { rows: data.data.data, total: data.data.total, error: false };
    } catch (error) {
      console.log(error);
      setLoading(false);
      snackbar.showError("Error In Loading Data.");
      // return { error: true };
    } finally {
      setLoading(false);
    }
    // setRowData([]);
  }
  return (
    <>
      <Box className="viewDetilsBox">
        <Grid container className="mb-2">
          <GridComp6
            title={"LINKED CUSTOMER RECORD"}
            data={rowData.linked_customer_record}
          />
          {rowData?.processed === "F" || rowData?.processed === "" ? (
            <Grid item xs={12} sm={4} md={4} className="m-b-10">
              <p className="tFormlabel">
                <FormGroup>
                  <FormControlLabel
                    control={<Checkbox disabled />}
                    label="PROCESSED"
                  />
                </FormGroup>
              </p>
            </Grid>
          ) : (
            <Grid item xs={12} sm={4} md={4} className="m-b-10">
              <p className="tFormlabel">
                <FormGroup>
                  <FormControlLabel
                    control={<Checkbox checked disabled />}
                    label="PROCESSED"
                  />
                </FormGroup>
              </p>
            </Grid>
          )}
          {/* <CustomCheckBox title={"PROCESSED"} data={rowData.crm_quote_id} /> */}
          <GridComp6
            title={"GP TRANSACTION ID"}
            data={rowData.gp_transaction_id}
          />
          {rowData?.resend_email === "F" ||
          rowData?.resend_email === "" ? (
            <Grid item xs={12} sm={4} md={4} className="m-b-10">
              <p className="tFormlabel">
                <FormGroup>
                  <FormControlLabel
                    control={<Checkbox disabled />}
                    label="RESEND EMAIL"
                  />
                </FormGroup>
              </p>
            </Grid>
          ) : (
            <Grid item xs={12} sm={4} md={4} className="m-b-10">
              <p className="tFormlabel">
                <FormGroup>
                  <FormControlLabel
                    control={<Checkbox checked disabled />}
                    label="RESEND EMAIL"
                  />
                </FormGroup>
              </p>
            </Grid>
          )}
          {/* <CustomCheckBox
            title={"RESEND EMAIL"}
            data={rowData.other_contract_instructions}
          /> */}
          <GridComp6
            title={"INVOICE ADDITIONAL ATTATCHMENTS"}
            data={rowData.invoice_additional_attachments}
          />
          <GridComp6 title={"NOTE"} data={rowData.note} />
          {/* <GridComp4
            title={"OPENAIR INVOICE NUMBER"}
            data={rowData.openair_invoice_number}
          />
          <GridComp4
            title={"OPENAIR: INVOICE LINK"}
            data={rowData.openair_invoice_link}
          />
          <GridComp4
            title={"OPENAIR: EXPORT ERROR (2)"}
            data={rowData.openair_export_error}
          />
          <CustomCheckBox title={"HELIX"} data={rowData.helix} />
          <GridComp4 title={"BUSINESS UNIT"} data={rowData.business_unit} />
          <CustomCheckBox
            title={"DO NOT MIGRATE TO QUORUM"}
            data={rowData.do_not_migrate_to_quorum}
          /> */}
        </Grid>
        <Tabs
          value={tabIndexRelatedRecord}
          // onChange={handleChange}
          onChange={(e, nv) => {
            setTabIndexRelatedRecord(nv);
          }}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
          className={`${classes.spacedTabs} tabs-sub-bkg`}
          // className="tabs-sub-bkg"
        >
          <Tab label="BG Summary Records" />
          <Tab label="FAM Expense/Income" />
          <Tab label="FAM Depreciation History" />
          <Tab label="FAM Asset" />
        </Tabs>
        <TabPanel value={tabIndexRelatedRecord} index={0}>
          <Grid container spacing={1} style={{ margin: "1px" }}>
            <Grid item xs={12} sm={4} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel id="demo-simple-select-label">VIEW</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value=""
                  label="VIEW"
                >
                  <MenuItem value="Default View">Default View</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={4} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel id="demo-simple-select-label">
                  BG Summary Records
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value=""
                  label="VIEW"
                >
                  <MenuItem value="Default View">Default View</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <Box
            sx={{
              p: 1,
            }}
          >
            <Stack spacing={2} direction="row">
              <Button className="blue-button">New BG Summary Records</Button>
              <Button className="blue-button">Attach</Button>
              <Button className="blue-button">Customize View</Button>
            </Stack>
          </Box>
          <AgGridPaginatedTable
            getTableRows={undefined}
            columns={BgSummaryrecordTable}
            refreshCounter={0}
            perPage={5}
          />
        </TabPanel>
        <TabPanel value={tabIndexRelatedRecord} index={1}>
          <Grid container spacing={1} style={{ margin: "1px" }}>
            <Grid item xs={12} sm={4} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel id="demo-simple-select-label">VIEW</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value=""
                  label="VIEW"
                >
                  <MenuItem value="Default View">Default View</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={4} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel id="demo-simple-select-label">
                  FAM Expense/Income
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value=""
                  label="VIEW"
                >
                  <MenuItem value="Default View">Default View</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <Box
            sx={{
              p: 1,
            }}
          >
            <Stack spacing={2} direction="row">
              <Button className="blue-button">New FAM Expense/Income</Button>
              <Button className="blue-button">Attach</Button>
              <Button className="blue-button">Customize View</Button>
            </Stack>
          </Box>
          <AgGridPaginatedTable
            getTableRows={undefined}
            columns={BgIncomeTable}
            refreshCounter={0}
            perPage={5}
          />
        </TabPanel>
        <TabPanel value={tabIndexRelatedRecord} index={2}>
          <Grid container spacing={1} style={{ margin: "1px" }}>
            <Grid item xs={12} sm={4} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel id="demo-simple-select-label">VIEW</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value=""
                  label="VIEW"
                >
                  <MenuItem value="Default View">Default View</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={4} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel id="demo-simple-select-label">
                  FAM Depreciation History
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value=""
                  label="VIEW"
                >
                  <MenuItem value="Default View">Default View</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <Box
            sx={{
              p: 1,
            }}
          >
            <Stack spacing={2} direction="row">
              <Button className="blue-button">
                New FAM Depreciation History
              </Button>
              <Button className="blue-button">Attach</Button>
              <Button className="blue-button">Customize View</Button>
            </Stack>
          </Box>
          <AgGridPaginatedTable
            getTableRows={undefined}
            columns={BgDeprecitionHistoryTable}
            refreshCounter={0}
          />
        </TabPanel>
        <TabPanel value={tabIndexRelatedRecord} index={3}>
          <Grid container spacing={1} style={{ margin: "1px" }}>
            <Grid item xs={12} sm={4} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel id="demo-simple-select-label">VIEW</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value=""
                  label="VIEW"
                >
                  <MenuItem value="Default View">Default View</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={4} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel id="demo-simple-select-label">FAM Asset</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value=""
                  label="VIEW"
                >
                  <MenuItem value="Default View">Default View</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <Box
            sx={{
              p: 1,
            }}
          >
            <Stack spacing={2} direction="row">
              <Button className="blue-button">New FAM Asset</Button>
              <Button className="blue-button">Attach</Button>
              <Button className="blue-button">Customize View</Button>
            </Stack>
          </Box>
          <AgGridPaginatedTable
            getTableRows={undefined}
            columns={BgFAMAssetTable}
            refreshCounter={0}
          />
        </TabPanel>
      </Box>
    </>
  );
}
